import { DateTime } from '@cheqroom/date-time';

/**
 * Fix Python dates from the API that do not have real timezone information.
 */
export const fixPythonDates = (data: unknown): unknown => {
	if (DateTime.isISOString(data as string)) {
		return DateTime.stripTimeZone(data as string);
	}

	if (data instanceof Object || Array.isArray(data)) {
		const obj = data as Record<string, unknown>;
		Object.entries(obj).forEach(([key, value]) => {
			obj[key] = fixPythonDates(value);
		});
	}

	return data;
};
